
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/gastronomy",
      function () {
        return require("private-next-pages/blog/gastronomy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/gastronomy"])
      });
    }
  